import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function createAccessRulesAPI(accessRule) {
  const url = `${AWS_API_URL}/2n/access-rules`;
  const source = (accessRule && accessRule.accessRule) || accessRule || {};

  return postRequest(url, {
    data: {
      name: source.name,
      zoneId: source.zoneId,
      groupId: source.groupId,
      timeProfileId: source.timeProfileId,
    },
  },
  await authorize());
}
